<section class="teaser" [attr.data-cy]="'popup-traffic-teaser'">
  <p class="teaser__eyebrow">Vehicle traffic</p>
  <h5 class="teaser__title">See how many cars pass every road here</h5>
  <p class="teaser__lead">
    Segment-level counts tell you which street, which hour and which month.
  </p>

  <ul class="teaser__cards" role="list">
    <li class="card" role="listitem" *ngFor="let card of cards">
      <span class="card__icon">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
          [ngSwitch]="card.icon"
        >
          <!-- A road forking into segments. -->
          <g *ngSwitchCase="'segments'">
            <path d="M4 20c3-4 5-6 8-8s5-4 8-8" />
            <path d="M12 12c2 2 4 4.5 5 8" />
            <circle cx="8" cy="16.2" r="1.4" />
            <circle cx="16" cy="7.8" r="1.4" />
          </g>
          <!-- Daily curve: two peaks. -->
          <g *ngSwitchCase="'hourly'">
            <path d="M3 20h18" />
            <path d="M3 17c2 0 3-9 5-9s3 6 4 6 2-8 4.5-8S19 17 21 17" />
          </g>
          <g *ngSwitchCase="'trucks'">
            <path d="M2.5 6.5h11v9.5h-11z" />
            <path d="M13.5 9.5h4l3 3.2v3.3h-7" />
            <circle cx="6.5" cy="17.5" r="1.7" />
            <circle cx="17" cy="17.5" r="1.7" />
          </g>
          <!-- Monthly bars, high in summer. -->
          <g *ngSwitchCase="'monthly'">
            <path d="M3 20h18" />
            <path d="M5 17v-3M8 17v-5M11 17v-8M14 17v-9M17 17v-6M20 17v-3.5" />
          </g>
        </svg>
      </span>
      <span class="card__title">{{ card.title }}</span>
      <span class="card__text">{{ card.text }}</span>
    </li>
  </ul>

  <button
    type="button"
    class="teaser__cta"
    (click)="handleRequest()"
    [attr.data-cy]="'popup-traffic-teaser-cta'"
  >
    See road-by-road traffic
    <svg
      class="teaser__arrow"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M3 8h10M9 4l4 4-4 4" />
    </svg>
  </button>
</section>
